import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import { FormattedMessage } from 'react-intl';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  card: {
    display: 'flex',
  },
  content: {
    padding: theme.spacing(0, 3, 2.5, 3),
  },
  title: {
    width: '97%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  dialogAction: {
    padding: 16,
  },
}));

interface PermissionDeniedDialogProps {
  isOpenDialog: boolean;
  triggerDialog: Function;
}

const PermissionDeniedDialog = (props: PermissionDeniedDialogProps) => {
  const classes = useStyles();
  const { isOpenDialog, triggerDialog } = props;

  return (
    <Dialog open={isOpenDialog} maxWidth="sm">
      <div className={classes.card}>
        <div className={classes.title}>
          <DialogTitle id="welcome_page.popup_permission_denied.title">
            <FormattedMessage id="welcome_page.popup_permission_denied.title" />
          </DialogTitle>
          <IconButton
            id="welcome_page.popup_permission_denied.icon_close"
            onClick={() => triggerDialog()}
            aria-label="close"
            edge="end"
            size="small"
          >
            <CloseIcon fontSize="medium" />
          </IconButton>
        </div>
      </div>
      <DialogContent id="welcome_page.popup_permission_denied.content" className={classes.content}>
        <FormattedMessage id="welcome_page.popup_permission_denied.description" />
      </DialogContent>
    </Dialog>
  );
};

export default PermissionDeniedDialog;
